export type LoggerErrorMessage = Error | string | unknown;

export class LoggerError extends Error {
  constructor(name: string, error: LoggerErrorMessage) {
    super(error instanceof Error ? error.message : typeof error === 'string' ? error : 'unknown error');
    this.name = name;
    this.stack = error instanceof Error ? error.stack : this.stack;
  }
}
